import { ApopProps } from "../../../types";
import { Events } from "../common/json/clevertapEvents";

interface UpdatedData {
  [key: string]: any;
}

export function containsOther(input: string): boolean {
  return input?.includes("Other");
}

export function getSubmitData(
  isSpecificationDisabled: boolean,
  isBoard: boolean,
  data: any,
  handleEventTracking: ApopProps["handleEventTracking"],
): UpdatedData {
  const updatedData: UpdatedData = {
    educations: [
      {
        educationType: {
          id: data.educationType.id,
          text: data.educationType.text,
        },
        highestQualification: {
          text: containsOther(data.highestQualification.text)
            ? data.qualification
            : data.highestQualification.text,
        },
        yearOfPassing: data.passingYear.text,
      },
    ],
  };
  if (!isSpecificationDisabled && data.specialization) {
    updatedData["educations"][0]["specialization"] = {
      text: containsOther(data.specialization.text)
        ? data.manualSpecialization
        : data.specialization.text,
    };
  }
  if (data.institute) {
    updatedData["educations"][0]["college"] = {
      text: containsOther(data.institute.text)
        ? data.university
        : data.institute.text,
    };
  }

  if (isBoard) {
    if (data.board) {
      updatedData["educations"][0]["board"] = {
        id: data.board?.id,
        text: data.board?.text,
      };
    }
    if (data.medium) {
      updatedData["educations"][0]["medium"] = {
        id: data.medium?.id,
        text: data.medium?.text,
      };
    }
    if (data.percentage) {
      updatedData["educations"][0]["percentage"] = data.percentage.id;
    }
  }

  if (data.institute && !containsOther(data.institute.text)) {
    updatedData["educations"][0]["college"].id = data.institute.id;
  }

  if (
    data.highestQualification &&
    !containsOther(data.highestQualification.text)
  ) {
    updatedData["educations"][0]["highestQualification"].id =
      data.highestQualification.id;
  }

  if (
    data.specialization &&
    !containsOther(data.specialization.text) &&
    !isSpecificationDisabled
  ) {
    updatedData["educations"][0]["specialization"].id = data.specialization.id;
  }

  if (data.linkedin) {
    updatedData["socialPresence"] = {
      url: data.linkedin,
      name: "LinkedIn",
    };
    handleEventTracking({
      eventType: "eventPush",
      eventName: Events["LINKED_IN"].linkedInClick["EVENTNAME"],
      eventProps: Events["LINKED_IN"].linkedInClick["EVENTOBJ"],
    });
  }

  if (data.isToggled) {
    updatedData["profileAutoUpdate"] = {
      linkedInConsent: true,
    };
  } else {
    updatedData["profileAutoUpdate"] = {
      linkedInConsent: false,
      reason: "OTHER_REASONS",
    };
  }

  return updatedData;
}
